import React from 'react';
import DatePicker, {registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {ptBR} from 'date-fns/locale/pt-BR';

registerLocale('pt-BR', ptBR)

const maskValue = (value, showTime, onlyTime) => {
    const digits = String(value ?? "").replace(/\D/g, "");
    const groups = onlyTime ? [2, 2] : (showTime ? [2, 2, 4, 2, 2] : [2, 2, 4]);
    const separators = onlyTime ? [":"] : (showTime ? ["/", "/", " ", ":"] : ["/", "/"]);
    const maxLength = groups.reduce((total, length) => total + length, 0);
    const limitedDigits = digits.slice(0, maxLength);
    const parts = [];
    let offset = 0;

    groups.forEach((length, index) => {
        const part = limitedDigits.slice(offset, offset + length);
        if (!part) return;

        parts.push(part);
        offset += part.length;

        if (part.length === length && offset < limitedDigits.length && separators[index]) {
            parts.push(separators[index]);
        }
    });

    return parts.join("");
}

const MaskedInput = React.forwardRef(({ value, onChange, onClick, showTime, onlyTime = false, ...props }, ref) => {
    const handleChange = (event) => {
        event.target.value = maskValue(event.target.value, showTime, onlyTime);
        onChange?.(event);
    }

    return (
        <input
            ref={ref}
            {...props}
            value={value ?? ""}
            onChange={handleChange}
            onClick={onClick}
            inputMode="numeric"
        />
    );
});

MaskedInput.displayName = "MaskedInput";

const InputDateTime = ({selected, onChange, onBlur, id, label, disabled, showTime, onlyTime= false, col, filterDate, excludeDates}) => {
    const disableClas = disabled ? "bg-gray-200 text-gray-500" : "text-gray-900";

    const classNameInput = "block w-full px-2.5 pb-1 pt-1 text-sm bg-transparent border-[1px] rounded-[3px] border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 h-[32px] " + disableClas;
    const popperClassName = "input-datetime-popper z-[3000]";

    return (
        <>
            <div className={"flex relative group " + col}>
                {!showTime && onlyTime &&
                    <DatePicker
                        id={id}
                        timeCaption="Tempo"
                        selected={selected}
                        onChange={onChange}
                        locale="pt-BR"
                        dateFormat="HH:mm"
                        showTimeSelect
                        showTimeSelectOnly
                        disabled={disabled}
                        timeIntervals={30}
                        className={classNameInput}
                        popperClassName={popperClassName}
                        portalId="input-datetime-portal"
                        calendarClassName="input-datetime-calendar"
                        filterDate={filterDate}
                        excludeDates={excludeDates}
                        onBlur={onBlur}
                        customInput={<MaskedInput onlyTime={true} />}
                    />
                }
                {
                    showTime && !onlyTime &&
                    <DatePicker
                        id={id}
                        timeCaption="Hora"
                        selected={selected}
                        onChange={onChange}
                        locale="pt-BR"
                        timeFormat="HH:mm"
                        dateFormat="dd/MM/yyyy HH:mm"
                        showTimeSelect
                        disabled={disabled}
                        customInput={<MaskedInput showTime={true} />}
                        className={classNameInput}
                        popperClassName={popperClassName}
                        portalId="input-datetime-portal"
                        calendarClassName="input-datetime-calendar input-datetime-calendar-with-time"
                        filterDate={filterDate}
                        excludeDates={excludeDates}
                        onBlur={onBlur}
                    />
                }

                {
                    !showTime && !onlyTime &&
                    <DatePicker
                        id={id}
                        selected={selected}
                        onChange={onChange}
                        locale="pt-BR"
                        dateFormat="dd/MM/yyyy"
                        disabled={disabled}
                        customInput={<MaskedInput showTime={false}/>}
                        className={classNameInput}
                        popperClassName={popperClassName}
                        portalId="input-datetime-portal"
                        calendarClassName="input-datetime-calendar"
                        filterDate={filterDate}
                        excludeDates={excludeDates}
                        onBlur={onBlur}
                    />
                }

                <label htmlFor={id} style={{ whiteSpace: "nowrap" }}
                       className={`absolute text-sm px-1 text-gray-500 duration-300 transform z-10 origin-[0] left-2.5 max-w-full truncate
                       ${selected ? "-translate-y-4 scale-75 top-[5px]" : "top-[6px] translate-y-0 scale-100 group-focus-within:-translate-y-4 " +
                       "group-focus-within:scale-75 group-focus-within:top-[5px]"}
                       ${disabled ? (selected ? "bg-label-disabled" : "") : "bg-white"}`}>
                    {label}
                </label>
            </div>
        </>
    );
};

export default InputDateTime;
